// import the select component from bootstrap react
import { useContext } from 'react';
import { Form } from 'react-bootstrap';
import { useRef, useEffect } from 'react';
import { VideoDevicesContext } from 'context/VideoDevicesContext';
import { getStreamFromVideoDeviceId, getVideoDevices } from 'features/room/mediaDevices/videoDeviceHelper';

// redux
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { streamUpdated, StreamsState, StreamsByDevice } from 'features/streams/streams-slice';
import MediaStreamsContext from 'context/MediaStreamsContext';
import { MediaStreamList} from 'app/types';
import { selectedStreamUpdated } from 'features/streams/selected-stream-slice';
//import { mediaDevicesListUpdated_Async } from 'actions/media-devices';

export function VideoDeviceSelector(props: { deviceType: keyof StreamsByDevice }) {
  const dispatch = useAppDispatch();

  //context
  const [mediaDevices, setVideoDevices] = useContext(VideoDevicesContext);
  const [mediaStreams, setMediaStreams] = useContext(MediaStreamsContext);

  // Selected stream ID
  const selectedStream = useAppSelector((state) => state.selectedStream.streamId);
  // Current stream ID (Used to check if the selected stream is the same as the current stream on change)
  const currentStreamId = useRef<string>("");

  // HTML Select element
  const selectElement = useRef<HTMLSelectElement>(null);
  //const [localStreams, setLocalStreams] = useContext(LocalStreamsContext);

  const elementDescription = `Local ${props.deviceType}`

  // Mounting component. Selecting the first video device by default.
  useEffect(() => {
    getVideoDevices().then(async devices => {
      setVideoDevices(devices);
      setTimeout(handleChange, 1000);
      // Select the first video device by default


      // Set the current stream ID
      currentStreamId.current = selectElement.current?.value as string;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <>
      <Form.Select ref={selectElement} onChange={handleChange}>
        {
          mediaDevices.map(videoDevice => {
            return (
              <option key={videoDevice.deviceId} value={videoDevice.deviceId}>
                {videoDevice.label}
              </option>
            );
          })
        }
      </Form.Select>
    </>
  );

  async function handleChange() {
    console.debug(`Video Selector Change (${elementDescription})`, " - Select Element: ", selectElement.current, " - Select Element Value: ", selectElement.current?.value);


    if (selectElement.current /*&& selectElement.current.value*/) {
      if (selectElement.current.selectedIndex < 0)
        selectElement.current.selectedIndex = 0;
      if (selectElement.current.value === "") {
        console.debug("No video device selected. Not getting stream");
        return;
      }

      //console.debug(selectElement.current.selectedIndex,selectElement.current.options.item(selectElement.current.selectedIndex)?.value);
      const newStream = await getStreamFromVideoDeviceId(selectElement.current.value);

      // Add the stream to mediaStreams context
      let newStreams: MediaStreamList = mediaStreams;
      newStreams[newStream.id as string] = newStream;
      setMediaStreams(newStreams);

      // Replace the corresponding stream in the store
      const newStreamDetails = {
        origin: "local" as keyof StreamsState,
        deviceType: props.deviceType,
        streamDetails: {
          streamId: newStream.id
        }
      };

      dispatch(streamUpdated(newStreamDetails));

      // If the selected stream is the same as the current stream, also update the selected stream
      if (currentStreamId.current === selectedStream) {
        dispatch(selectedStreamUpdated(newStream.id));
      }
      // Set the current stream ID
      currentStreamId.current = newStream.id as string;

    } else {
      console.error("No video device selected. Not getting stream");
    }
  }
}